import { Component, ElementRef, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { environment } from 'src/environments/environment';

// Services
import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';
import * as _ from 'lodash';

const ID_SORTEIO = 2;

@Component({
  selector: 'app-lp-promocional',
  templateUrl: './lp-promocional.component.html',
  styleUrls: ['./lp-promocional.component.scss'],
})
export class LpPromocionalComponent implements OnInit {
  public menuItems: any[] = [
    {
      label: 'Como Participar',
      irPara: 'como-participar',
      somenteParticipante: false,
      destacado: false,
    },
    {
      label: 'Prêmio',
      irPara: 'premio',
      somenteParticipante: false,
      destacado: false,
    },
    {
      label: 'Meus Nºs da sorte',
      irPara: 'numeros-da-sorte',
      somenteParticipante: true,
      destacado: true,
    },
    {
      label: 'Dúvidas',
      irPara: 'duvidas',
      somenteParticipante: false,
      destacado: false,
    },
    {
      label: 'Regulamento',
      irPara: 'regulamento',
      somenteParticipante: false,
      destacado: false,
    },
  ];

  public usuarioLogado: boolean = false;
  public participando: boolean = false;

  // Variáveis de Controle de Exibição
  public exibirModalParticipar: boolean = false;
  public participarBloqueado: boolean = true;
  public menuMobileAberto: boolean = false;

  public exibirModalGeracaoNumero: boolean = false;
  public numeroGerado: boolean = false;

  public exibirModalLocalizacao: boolean = false;
  public idExperienciaLocalizacao: number = 43;

  public exibirModalRegulamento: boolean = false;
  public regulamento: string[] = [];
  public obtendoRegulamento: boolean = false;

  public faq: any[] = [];

  public membro: any;

  public exibirModalGanhadores: boolean = false;
  public ganhadores: any[] = [];
  public filtroGanhadorNome: string = '';

  public membroSorteado: boolean = false;

  public exibirModalVerificacao: boolean = false;

  public exibirKitHml: boolean = !environment.production;

  // Calendário
  public dataAtual: number = new Date().getTime();
  public dataInicio: number = new Date(2023, 4, 22).getTime();
  public dataInicioSorteio: number = new Date(2023, 5, 30, 23, 59).getTime();
  public dataFimSorteio: number = new Date(2023, 6, 7).getTime();
  public dataExibicaoResultado: number = new Date(2023, 6, 5).getTime();

  // Formulário Número da Sorte
  public numeroSorteForm: UntypedFormGroup;
  public codigoInvalido: boolean = false;
  public numeroSorteSelecionado: any;
  public numerosSorte: any[] = [];

  // Loadings
  public obtendoMembro: boolean = false;
  public obtendoNumerosSorte: boolean = false;
  public gerandoNumeroSorte: boolean = false;
  public carregandoParticipacao: boolean = false;
  public obtendoGanhadores: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private fidelidadeService: FidelidadeService,
    private elementRef: ElementRef,
    private formBuilder: UntypedFormBuilder
  ) {
    this.numeroSorteForm = this.formBuilder.group({
      codigo: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.obterFaq();

    this.usuarioLogado = this.authService.LocalStorage.usuarioValido();
    if (this.usuarioLogado) this.obterMembro();
  }

  private obterFaq(): void {
    this.fidelidadeService
      .obterFAQPorNome('Promoção dia dos Namorados 2023')
      .subscribe({
        next: (res: any) => this.processarSucessoObterFaq(res),
      });
  }

  private obterMembro(): void {
    this.obtendoMembro = true;

    var membro = this.authService.LocalStorage.obterMembro();
    this.processarSucessoObterMembro(membro);
  }

  private obterMembroParticipando(): void {
    const sorteio = {
      id: 0,
      idSorteio: ID_SORTEIO,
      idMembro: this.membro.id,
    };

    this.fidelidadeService.obterSorteiosPorMembro(sorteio).subscribe({
      next: () => {
        this.participando = true;
        this.obtendoMembro = false;

        this.obterNumerosDaSorte();
        this.obterMembroSorteado();
      },
      error: () => {
        this.obtendoMembro = false;
        this.verificarExibicaoPopupParticipar();
      },
    });
  }

  public obterMembroSorteado(): void {
    if (this.dataAtual < this.dataExibicaoResultado) return;

    this.fidelidadeService
      .obterResultadoSorteio(ID_SORTEIO, this.membro.id)
      .subscribe({
        next: () => (this.membroSorteado = true),
      });
  }

  public gerarNumeroSorte(): void {
    this.gerandoNumeroSorte = true;

    const codigo = this.numeroSorteForm.value.codigo;

    this.fidelidadeService
      .cadastrarPincodeSorteio(ID_SORTEIO, this.membro.id, codigo)
      .subscribe({
        next: () => {
          this.numeroGerado = true;

          this.gerandoNumeroSorte = false;

          this.obterNumerosDaSorte();
        },
        error: (err: any) => {
          console.error(
            'Ocorreu um erro ao tentar gerar o número da sorte',
            err
          );

          this.codigoInvalido = true;

          this.gerandoNumeroSorte = false;
        },
      });
  }

  public obterRegulamentoPromocao(exibirModal: boolean = false): void {
    this.obtendoRegulamento = true;

    this.fidelidadeService
      .obterConfiguracaoPorDescricao('Regulamento_Promocao_Namorados')
      .subscribe({
        next: (res: any) =>
          this.processarSucessoObterConfiguracao(res, exibirModal),
        error: () => {
          this.obtendoRegulamento = false;
        },
      });
  }

  private obterNumerosDaSorte(): void {
    this.obtendoNumerosSorte = true;
    const sorteio = {
      id: 0,
      idSorteio: ID_SORTEIO,
      idMembro: this.membro.id,
    };
    this.fidelidadeService.obterComprasSorteio(sorteio).subscribe({
      next: (res: any) => {
        this.numerosSorte = res;
        this.obtendoNumerosSorte = false;
      },
      error: (err: any) => {
        console.error('Erro', err);
        this.obtendoNumerosSorte = false;
      },
    });
  }

  public participarSorteio(): void {
    const sorteio = {
      id: 0,
      idSorteio: ID_SORTEIO,
      idMembro: this.membro.id,
    };

    this.carregandoParticipacao = true;

    this.fidelidadeService.participarSorteio(sorteio).subscribe({
      next: () => this.processarSucessoParticipar(),
      error: () => {
        this.carregandoParticipacao = false;
        this.exibirModalParticipar = false;
        this.exibirModalVerificacao = true;
      },
    });
  }

  private obterGanhadores(): void {
    this.obtendoGanhadores = true;

    this.fidelidadeService.obterResultadoSorteio(ID_SORTEIO).subscribe({
      next: (res: any[]) => this.processarSucessoObterGanhadores(res),
      error: () => {
        this.obtendoGanhadores = false;
      },
    });
  }

  // Métodos auxiliares para sucesso e falha
  private processarSucessoObterFaq(res: any): void {
    res = res.resultado;

    const faq: any[] = [];

    for (let i = 0; i < res.length; i++) {
      faq.push({
        pergunta: res[i].pergunta,
        resposta: res[i].resposta,
      });
    }

    this.faq = faq;
  }

  private processarSucessoObterConfiguracao(
    res: any,
    exibirModal: boolean
  ): void {
    this.regulamento = res.valor.split('   ');
    this.exibirModalRegulamento = exibirModal;
    this.obtendoRegulamento = false;
  }

  private processarSucessoObterMembro(res: any): void {
    this.membro = res;

    this.obterMembroParticipando();
  }

  private processarFalhaObterMembro(err: any): void {
    console.error('Ocorreu uma falha ao tentar obter o membro', err);
    this.obtendoMembro = false;
    this.verificarExibicaoPopupParticipar();
  }

  private processarSucessoParticipar(): void {
    this.participando = true;
    this.carregandoParticipacao = false;
  }

  private processarSucessoObterGanhadores(res: any[]): void {
    res.forEach((ganhador) => {
      const nomeSplit: string[] = ganhador.nome.split(' ');

      let nomeAbreviado = nomeSplit.shift();
      for (let sobrenome of nomeSplit)
        nomeAbreviado += ` ${sobrenome[0].toUpperCase()}.`;
      ganhador.nomeAbreviado = nomeAbreviado;
    });

    this.ganhadores = res;

    this.obtendoGanhadores = false;
  }

  // Métodos Auxiliares
  public scrollTo(id: string): void {
    if (id === 'regulamento') {
      this.abrirModalRegulamento();
      return;
    }

    const elem = document.getElementById(id);
    if (!elem) return;

    const offsetHeader = id === 'premio' ? 100 : 0;
    window.scrollTo({
      top: elem.offsetTop - offsetHeader,
      left: 0,
      behavior: 'smooth',
    });

    this.menuMobileAberto = false;
  }

  public irParaLogin(): void {
    const link = '/promocao?abrirPopupParticipar=1';

    this.router.navigate(['/home'], {
      queryParams: {
        origem: 6,
        redirectLink: btoa(link),
      },
    });
  }

  private abrirModalRegulamentoParticipar(): void {
    if (this.dataAtual > this.dataInicioSorteio) return;

    if (this.regulamento.length === 0) this.obterRegulamentoPromocao();

    this.exibirModalParticipar = true;

    setTimeout(() => {
      const element = this.elementRef.nativeElement.querySelector(
        '#regulamento-container'
      );

      element.addEventListener('scroll', () => {
        if (!this.participarBloqueado) return;

        const regulamentoHeight: number = element.scrollHeight - 80;
        const scrollHeight: number = element.scrollTop + 1000;

        if (scrollHeight > regulamentoHeight) this.participarBloqueado = false;
      });
    }, 750);
  }

  public abrirModalGeracaoNumero(): void {
    this.numeroSorteForm.patchValue({ codigo: '' });
    this.numeroGerado = false;
    this.codigoInvalido = false;
    this.exibirModalGeracaoNumero = true;
  }

  public irParaAjuda(): void {
    this.router.navigate(['ajuda', 'namorados'], {
      queryParams: { tipoAtendimento: 'promocao_namorados' },
    });
  }

  public abrirModalRegulamento(): void {
    if (this.regulamento.length > 0) {
      this.exibirModalRegulamento = true;
      return;
    }

    this.obterRegulamentoPromocao(true);
  }

  private verificarExibicaoPopupParticipar(): void {
    this.route.queryParams.subscribe((params) => {
      if (
        params.abrirPopupParticipar &&
        Number(params.abrirPopupParticipar) === 1 &&
        !this.participando
      )
        this.abrirModalRegulamentoParticipar();
    });
  }

  public participar(): void {
    if (!this.usuarioLogado) {
      this.irParaLogin();
      return;
    }

    this.abrirModalRegulamentoParticipar();
  }

  public selecionarNumeroSorte(numeroSorte: any): void {
    this.numeroSorteSelecionado = numeroSorte;
  }

  public abrirModalGanhadores(): void {
    this.exibirModalGanhadores = true;

    if (this.ganhadores.length === 0) this.obterGanhadores();
  }

  public filtrarGanhadores(): any[] {
    return _.filter(this.ganhadores, (ganhador: any) => {
      return (
        this.filtroGanhadorNome === '' ||
        ganhador.nome
          .toLowerCase()
          .includes(this.filtroGanhadorNome.toLowerCase())
      );
    });
  }

  public kitHml(data: number): void {
    switch (data) {
      case 1:
        this.dataAtual = new Date(2023, 2, 10).getTime();
        break;
      case 2:
        this.dataAtual = new Date(2023, 3, 5).getTime();
        break;
      case 3:
        this.dataAtual = new Date(2023, 3, 6).getTime();
        break;
      case 4:
        this.dataAtual = new Date(2023, 3, 7).getTime();
        this.obterMembroSorteado();
        break;
      case 5:
        this.participando = true;
        break;
      case 6:
        this.participando = false;
        break;
    }
  }

  irParaValidaDados() {
    const link = '/promocao?abrirPopupParticipar=1';
    this.authService.LocalStorage.salvarDadosValidados(false);
    this.authService.LocalStorage.salvarRedirectLink(link);

    this.router.navigate(['/validar-dados']);
  }
}
